if (!window.roughEtiquetteInitialized) {
  window.roughEtiquetteInitialized = true;
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-re-open]');
    if (trigger) {
      const dialog = document.getElementById(trigger.dataset.reOpen);
      if (dialog) { dialog.showModal(); dialog.dataset.returnFocus = ''; window.reLastTrigger = trigger; }
      document.querySelectorAll('.re-mobile-menu[open]').forEach(menu => menu.removeAttribute('open'));
    }
    const close = event.target.closest('[data-re-close]');
    if (close) close.closest('dialog').close();
    if (event.target.matches('.re-dialog')) {
      const rect = event.target.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.target.close();
    }
    if (event.target.closest('.re-mobile-menu a')) document.querySelectorAll('.re-mobile-menu[open]').forEach(menu => menu.removeAttribute('open'));
  });
  document.addEventListener('close', event => {
    if (event.target.matches('.re-dialog') && window.reLastTrigger) window.reLastTrigger.focus();
  }, true);
}
